module.exports = __webpack_public_path__ + "img/NL354.c2804583.png";